module.exports = __webpack_public_path__ + "img/34.d8b46dc0.jpg";